import React, {FunctionComponent} from 'react';
import {useDispatch} from "react-redux";
import {removePersistence, unsetImpersonation} from '../../../reducers/auth';
import {useTranslation} from 'react-i18next';

import './ImpersonificationCorner.scss';
import {useHistory} from 'react-router';
import {clearStateContract} from '../../../reducers/contracts';


interface ImpersonificationCornerProps {
  impersonateProfile: any,
}

const ImpersonificationCorner: FunctionComponent<ImpersonificationCornerProps> = (props: any) => {
    const {t} = useTranslation();
    const history = useHistory();

    const dispatch = useDispatch();
    const handleActiveImpersonation = () => {
        dispatch(unsetImpersonation());
        dispatch(removePersistence());
        dispatch(clearStateContract());
        history.push("/dashboard");
    };
    const {impersonateProfile} = props;

    return(
        <>
            <div className="c0" data-testid="ImpersonificationCorner">
                { impersonateProfile ?

                    <p className="c0-text">
                       {t("dashboard.impersonation.profile")}{ " "+ impersonateProfile.name +" " + impersonateProfile.surname}
                    </p>
                    :
                    null
                }
                <button data-testid="buttonImpersonificationCorner" className="c0-btn" onClick={() => handleActiveImpersonation()}>
                     <span className="gc-icon-thick-close"></span>
                </button>
            </div>
            <div className="c1">
            </div>
            <div className="c2">
            </div>
            <div className="c3">
            </div>
            <div className="c4">
            </div>
        </>
    )


};
export default ImpersonificationCorner;
